<template>
  <div class="flex flex-col gap-y-4 w-[344px]">
    <NText variant="caption1" weight="regular" class="whitespace-pre-line">
      {{ t('ipo.automaticIpoRequestDialogDescription') }}
    </NText>

    <a :href="AUTOMATIC_IPO_REQUEST_LINK" target="_blank">
      <NButton variant="flat" class="w-full">
        <NegarLinkIcon class="me-1" />

        <NText variant="caption1" weight="medium">
          {{ t('ipo.requestEasyIpoPurchase') }}
        </NText>
      </NButton>
    </a>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { NegarLinkIcon } from '@negar/icons';
import { AUTOMATIC_IPO_REQUEST_LINK } from '@core/ipo';

const { t } = useI18n();
</script>
